import _ from 'lodash';
import moment from 'moment';
import * as actionTypes from '../../constants/actionTypes';
// import update from 'react/lib/update';
import * as Misc from '../../misc';
import {Map, List, fromJS} from 'immutable';
import {getJobSalesPerson, getLeadTypeAsFromBackend} from "../../utilities/job";

export const SEND_EMAIL_CHECKBOXES = ["sendCustomerEmail", "sendFabricatorEmail", "sendSalesPersonEmail"];

const initialState = {
  sentinel: false,
  fetching: false,
  jobs: [],
  relatedJobs: [], // jobs that are assigned from another fabricator using associate job popup. request in NotificationsButton
  relatedJobsFabricatorId: null, // fabricator id that has the latest response with related jobs
  permissions: {}, // permissions for current user per fabricator
  jobStatusDropDownVisible: false,
  leadTypeDropDownVisible: false,
  // filters: [{
  //   name: "leadType",
  //   value: "All" // All should be by the default // or array
  // }],
  filters: [],
  sortBy: [{name: "daysOpen", value: "desc"}],
  editableQuote: null, // the quote for which we currently show the Quote editing tool, null - tool not visible
  editableQuoteShow: '', // when quoting tool loads, here we as to show notes, uploads or nothing
  expandedJobId: -1, // currently expanded job
  page: 0,
  term: '',
  totalPages: 0,
  logEntryJob: null, // an object holding the data for jobBoard entry shown on log window
  salesPeople: Map({
    rows: List()
  }),
  loadingData: false,
  showJobBoardFiltersPopup: false,
  filtersPopupResponseReceived: false,
  filtersPopupSalesPersons: [],
  filtersPopupStores: [],
  sendEmailCheckboxes: [], // SEND_EMAIL_CHECKBOXES
};

function splitName(name)
{
  var nameParts = (name || "Unknown").split(' ');
  var result = {
    firstName: "",
    lastName: ""
  };
  if(nameParts.length > 1) {
    for(var i = 0; i < nameParts.length; i++) {
      if(i < nameParts.length - 1) {
        result.firstName += " " + nameParts[i];
      }
      else {
        result.lastName = nameParts[i];
      }
    }
  }
  else {
    result.firstName = nameParts[0];
  }
  return result;
}

function setJobs(state, action) {
  const {usePingWidget} = action.payload;
  let jobs = action.payload.jobs || [];
  let responseRelated = action.payload.relatedJobs || [];
  if (responseRelated.length) {
    const jobsTimeStamps = jobs.map(normalJob => moment(normalJob.created).unix());
    const relatedJobs = responseRelated
      .filter(job => { // they should be displayed on the next page
        const created = moment(job.created).unix();
        //1) first check if they should be on the page?
        if (jobsTimeStamps.length) { // no jobs in response? why
          if (state.sortBy && state.sortBy[0] && (state.sortBy[0].name === "daysOpen") && (state.sortBy[0].value === "asc")) {
            if (!(jobsTimeStamps.some(timeStamp => timeStamp > created)
              && (action.payload.page === 0 || Math.max(...jobsTimeStamps) > created))) {
              return false
            }
          } else if (!(jobsTimeStamps.some(timeStamp => timeStamp < created)
            && (action.payload.page === 0 || Math.max(...jobsTimeStamps) < created))) {
            return false
          }
        }
        //2) search term
        if (state.term) {
          if (!isNaN(+state.term)) {
            return ("" + job.id).includes(state.term)
          }
          if (![job.customerInfo.email, job.customerInfo.name, job.fabricatorInfo.email, job.fabricatorInfo.name].some(value => {
            return value.includes(state.term)
          })) {
            return false
          }
        }
        //3) filters
        if (state.filters && state.filters.length) {
          for (const filter of state.filters) {
            if (filter.name === "salesPerson") {
              const jobSalesPerson = getJobSalesPerson(job);
              return typeof jobSalesPerson === "string" && jobSalesPerson.indexOf(filter.value) > -1;
            }
          }
        }
        //4) sortBy (todo)
        return true
      })
      .map(job => {
        job.isRelated = true
        return job
      });
    // console.log("relatedJobs", responseRelated, relatedJobs);
    relatedJobs.forEach(job => {
      const created = moment(job.created).unix();
      const nextIndex = jobsTimeStamps.findIndex(timeStamp => timeStamp < created);
      jobs.splice(nextIndex, 0, job);
      jobsTimeStamps.splice(nextIndex, 0, created);
    });
  }
  _.each(jobs, function (job) {
    if (job.clientName) {
      var names = splitName(job.clientName);
      job.firstName = names.firstName;
      job.lastName = names.lastName;
      /*const names = (job.clientName || "Unknown").split(' ');
      if (names.length > 1) {
        job.lastName = names[names.length - 1];
        job.firstName = names[0];
        for(var i = 1; i <= names.length - 2; i++) {
          job.firstName += " " + names[i];
        }
      } else {
        job.firstName = job.clientName;
        job.lastName = '';
      }*/
    } else {
      job.firstName = job.lastName = '<NoName>';
    }

    job.salesPerson = getJobSalesPerson(job);

    job.grandTotal = job.total;
    if(job.grandTotal <= 0 && job.grandTotal != -1)
      job.grandTotal = _.sumBy(job.quotes, "quoteTotal");
    if(job.grandTotal <= 0 && job.grandTotal != -1) {
      job.grandTotal = _.sumBy(job.quotes, "stoneCost");
    }
    job.expanded = false;
    if (job.appointmentDate && job.appointmentDate.length > 0) {
      let momentDates = [];
      for(let i = 0; i < job.appointmentDate.length; i++) {
        if(job.appointmentDate[i] != null) {
          momentDates.push(moment(job.appointmentDate[i]));
        }
      }
      job.appointmentDate = momentDates;
    }

    job.leadType = job.leadType || job.subType || job.type || "Lead";
    job.logEntries = Array.isArray(job.logEntries) ? _.uniqBy(job.logEntries, "id") : [];
    job.loadingLogEntries = false;
    job.logEntriesLoaded = false;
    job.status = job.status || 'Started';

    job.phoneVerified = job.customerInfo && (job.customerInfo.phone == job.customerInfo.verifiedPhoneNumber);
  });

  return {
    ...state,
    jobs,
    usePingWidget,
    permissions: action.payload.permissions,
    fetching: false,
    invalidated: false,
    sentinel: false,
    page: action.payload.page,
    totalPages: action.payload.totalPages,
    loadingData: false,
    expandedJobId: -1
  };
}

function expandJob(state, action) {
  const job = action.payload;

  if (state.expandedJobId === job.id) {
    return {...state, expandedJobId: -1, leadTypeDropDownVisible: false};
  }

  return {...state, expandedJobId: job.id, leadTypeDropDownVisible: false};
}


function _updateJob(newJob, properties = {}, stateJobs = []) {
  return stateJobs.map(job => {
    if (job.id === newJob.id && job.jobIdType === newJob.jobIdType) {
      return {...job, ...properties}
    }
    return job
  })
}

export default function jobsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.JOB_BOARD_LOADING:
      return {...state, loadingData: true};
    case actionTypes.JOB_BOARD_LOADED:
      return setJobs(state, action);
    case actionTypes.JOB_BOARD_EXPAND_JOB:
      return expandJob(state, action);
    case actionTypes.JOB_BOARD_SHOW_QUOTEEDIT_LAYER:
      return {...state, editableQuote: action.payload.job, editableQuoteShow: action.payload.show};
    case actionTypes.JOB_BOARD_SHOW_LEADTYPE_DROPDOWN:
      return {...state, leadTypeDropDownVisible: action.payload};
    case actionTypes.JOB_BOARD_SHOW_JOBSTATUS_DROPDOWN:
      return {...state, jobStatusDropDownVisible: action.payload};
    case actionTypes.JOB_BOARD_SHOW_LOG_WINDOW:
      if (action.payload.show) {
        return {
          ...state,
          leadTypeDropDownVisible: false,
          jobStatusDropDownVisible: false,
          logEntryJob: action.payload
        };
      } else {
        return {...state, logEntryJob: null};
      }
    case actionTypes.JOB_BOARD_JOB_STATUS_CHANGED:
      let job = _.find(state.jobs, {'id': action.payload.initialJobId});
      if (job) {
        job.logEntries = [].concat(action.payload.logEntries);
        // if (action.payload.action !== 'update') {
        //   job.logEntriesLoaded = false;
        // }
        switch (action.payload.action) {
          case "changeJobStatus":
            job.status = action.payload.newLeadType;
            break;
          case "changeLeadType":
            const newLeadType = getLeadTypeAsFromBackend(action.payload.newLeadType);
            job.type = newLeadType;
            job.leadType = newLeadType;
            job.isDead = newLeadType === "DeadLead";
            break;
          default:
            break;
        }
        job = Object.assign({}, job);
      }
      // let expandedJobId = action.payload.action === 'update' ? state.expandedJobId : -1;
      return {...state, jobs: [].concat(state.jobs)};
    case actionTypes.JOB_BOARD_LOG_ENTRIES_LOADING: {
      let job = _.find(state.jobs, {id: action.payload.id, type: getLeadTypeAsFromBackend(action.payload.type)});
      if (job) {
        job.loadingLogEntries = true;
        job.logEntriesLoaded = false;
        job = Object.assign({}, job);
        return {...state, jobs: [].concat(state.jobs)};
      }
      console.error("Job not found!", action.payload.id, action.payload.type, "All current Jobs:", state.jobs);
      return {...state}
    }
    case actionTypes.JOB_BOARD_LOG_ENTRIES_LOADED: {
      const jobs = state.jobs.map(job => {
        if (job.id === action.payload.id && job.type === getLeadTypeAsFromBackend(action.payload.type)) {
          job.logEntries = [].concat(action.payload.logEntries);
          job.loadingLogEntries = false;
          job.logEntriesLoaded = true;
          job = Object.assign({}, job);
        }
        return job
      })
      return {...state, jobs};
    }
    case actionTypes.JOB_BOARD_MESSAGE_HISTORY_LOADING: {
      let job = _.find(state.jobs, {id: action.payload.id, type: getLeadTypeAsFromBackend(action.payload.type)});
      if (job) {
        job.loadingMessageHistory = true;
        job.messageHistoryLoaded = false;
        job = Object.assign({}, job);
        return {...state, jobs: [].concat(state.jobs)};
      }
      console.error("Job not found!", action.payload.id, action.payload.type, "All current Jobs:", state.jobs);
      return {...state}
    }
    case actionTypes.JOB_BOARD_MESSAGE_HISTORY_LOADED: {
      const jobs = state.jobs.map(job => {
        if (job.id === action.payload.id && job.type === getLeadTypeAsFromBackend(action.payload.type)) {
          job.messageHistory = [].concat(action.payload.messageHistory);
          job.loadingMessageHistory = false;
          job.messageHistoryLoaded = true;
          job = Object.assign({}, job);
        }
        return job
      })
      return {...state, jobs};
    }
    case actionTypes.JOB_BOARD_LOG_UPDATE_TEXT:
      state.logEntryJob.logEntry = {...state.logEntryJob.logEntry, message: action.payload.message};
      return {...state, logEntryJob: {...state.logEntryJob}};
    case actionTypes.JOB_BOARD_SHOW_FILTER:
      return Object.assign({}, state, {
        filters: [...action.payload],
        page: 0
      });
    case actionTypes.JOB_BOARD_SET_SORTING:
      return Object.assign({}, state, {
        sortBy: [...action.payload],
        page: 0
      });
    case actionTypes.JOB_BOARD_RESET_PAGE:
      return Object.assign({}, state, {
        filters: [],
        sortBy: [{name: "daysOpen", value: "desc"}],
        page: 0,
        term: ""
      });
    case actionTypes.JOB_BOARD_SET_SEARCH_TERM:
      return {...state, term: action.payload, page: 0};
    case actionTypes.JOB_BOARD_NOTE_SAVED: {
      // const job = _.find(state.jobs, {id: action.payload.jobId, jobIdType: action.payload.jobIdType});
      // job.notes.unshift(action.payload.note);
      // return {...state, jobs: [].concat(state.jobs)};
    }
      break;
    case actionTypes.CALENDAR_FETCHED_ENTRIES: {
      const job = _.find(state.jobs, {id: action.payload.jobId, jobIdType: action.payload.jobIdType});
      job.notes = [].concat(action.payload.notes);
      job.documents = [].concat(action.payload.documents).filter(document => {
        if (action.isClient) {
          return (document.documentType !== "invoice")
            && (document.documentType !== "order")
            && (document.documentType !== "cost_receipt")
            && (document.fileName !== "ReceiptCostImage")
        }
        return true
      });
      job.recordings = [].concat(action.payload.recordings);
      return {...state, jobs: [].concat(state.jobs)};
    }
    case actionTypes.SALES_PEOPLE_SUCCESS:
      return {...state, salesPeople: fromJS(action.payload)};
    case actionTypes.SALES_PERSON_ASSIGN_SUCCESS:
    case actionTypes.CALENDAR_SCHEDULE_ENTRY_SAVED:
    case actionTypes.JOB_BOARD_UPDATE_JOB:
      return {...state, jobs: _updateJob(action.payload.job, action.payload.properties, state.jobs)};
    case actionTypes.JOB_BOARD_SHOW_FILTERS_POPUP:
    case actionTypes.JOB_BOARD_SET_FILTERS_POPUP_RESPONSE:
    case actionTypes.JOB_BOARD_SET_SEND_EMAIL_CHECKBOXES:
    case actionTypes.JOB_BOARD_SET_RELATED_JOBS:
      return Object.assign({}, state, { ...action.payload });
  }

  return state;
}

